const { VITE_RWB_API } = import.meta.env;

export enum DownloadS3FileError {
  UrlFetchFailed = "UrlFetchFailed",
  InvalidUrlResponse = "InvalidUrlResponse",
  S3FetchFailed = "S3FetchFailed",
  InvalidS3Response = "InvalidS3Response",
}

export async function getS3PresignedDownloadUrl(fileKey: string) {
  let fetchResponse: Response;

  try {
    fetchResponse = await fetch(`${VITE_RWB_API}/file-browser/generate-download-url`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ key: fileKey }),
    });
  } catch (error) {
    throw new Error(DownloadS3FileError.UrlFetchFailed, { cause: error });
  }

  if (!fetchResponse.ok) {
    throw new Error(DownloadS3FileError.InvalidUrlResponse);
  }

  const presignedDownloadUrl = await fetchResponse.json();

  if (!presignedDownloadUrl) {
    throw new Error(DownloadS3FileError.InvalidUrlResponse);
  }

  return presignedDownloadUrl as string;
}

export async function downloadS3File(params: { fileKey: string }): Promise<Blob>;
export async function downloadS3File(params: { presignedUrl: string }): Promise<Blob>;
export async function downloadS3File(params: { fileKey: string } | { presignedUrl: string }) {
  const presignedDownloadUrl =
    "fileKey" in params ? await getS3PresignedDownloadUrl(params.fileKey) : params.presignedUrl;

  let fetchResponse: Response;

  try {
    fetchResponse = await fetch(presignedDownloadUrl);
  } catch (error) {
    throw new Error(DownloadS3FileError.S3FetchFailed, { cause: error });
  }

  if (!fetchResponse.ok) {
    throw new Error(DownloadS3FileError.InvalidS3Response);
  }

  const fileBlob = await fetchResponse.blob();
  return fileBlob;
}
